import { useMemo } from "react";
import MatchCard from "./matchCard/matchCard";
import "./roundPhaseWrapper.sass";

export default function RoundPhaseWrapper({
  title,
  matches,
  onSelectWinner,
  className = "",
  groupingStrategy = "none",
}) {
  const getGroupedMatches = useMemo(() => {
    switch (groupingStrategy) {
      case "pairs": {
        return matches.map((m, i) => ({
          id: i,
          matches: [m],
          layout: "pair",
        }));
      }
      case "quads": {
        const quads = [];
        for (let i = 0; i < matches.length; i += 4) {
          quads.push({
            id: Math.floor(i / 4),
            matches: matches.slice(i, i + 4),
            layout: "quad",
          });
        }
        return quads;
      }
      case "octets": {
        const octets = [];
        for (let i = 0; i < matches.length; i += 4) {
          const group = matches.slice(i, i + 4);
          octets.push({
            id: Math.floor(i / 4),
            subgroups: [
              { id: 0, matches: group.slice(0, 2) },
              { id: 1, matches: group.slice(2, 4) },
            ],
            layout: "octet",
          });
        }
        return octets;
      }
      default:
        return matches.map((m, i) => ({
          id: i,
          matches: [m],
          layout: "single",
        }));
    }
  }, [matches, groupingStrategy]);

  const renderMatchList = (items) =>
    items.map((match) => (
      <MatchCard key={match.id} match={match} onSelectWinner={onSelectWinner} />
    ));

  const renderGroup = (group) => {
    if (group.layout === "octet") {
      return (
        <div key={group.id} className="MatchMainGroup">
          {group.subgroups.map((sub) => (
            <div key={sub.id} className="MatchSubGroup">
              {renderMatchList(sub.matches)}
            </div>
          ))}
        </div>
      );
    }

    if (group.layout === "quad") {
      return (
        <div key={group.id} className="MatchGroup">
          {/* Agrupar en pares */}
          {[0, 2].map((i) => (
            <div key={`pair-${i}`} className="matchPairs">
              {renderMatchList(group.matches.slice(i, i + 2))}
            </div>
          ))}
        </div>
      );
    }

    const classMap = {
      pair: `MatchPair ${group.id % 2 === 1 ? "pair-end" : "pair-start"}`,
      single: "",
    };

    return (
      <div key={group.id} className={classMap[group.layout] || ""}>
        {renderMatchList(group.matches)}
      </div>
    );
  };

  return (
    <div className={`RoundPhase ${className}`}>
      <div className="RoundTitle">
        <p>{title}</p>
      </div>
      <div className="RoundMatches">
        {getGroupedMatches.map((group) => renderGroup(group))}
      </div>
    </div>
  );
}